import { useT } from "@/i18n"

/**
 * The bare problem statement that sits directly under the hero with no
 * heading (issue #87). Narrow measure, relaxed leading.
 */
export default function Pain() {
  const { t } = useT("content")

  return (
    <section className="mx-auto max-w-160 px-6 pt-12 pb-8 text-center sm:pt-16 sm:pb-10">
      <p className="text-lg leading-relaxed text-foreground/80 sm:text-xl">
        {t("home.pain")}
      </p>
    </section>
  )
}
